import { createGlobalStyle } from 'styled-components/macro';

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    font-weight: ${({ theme }) => theme.fontWeight.normal};
  }

  html {
    box-sizing: border-box;
    font-size: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    font-family: ${({ theme }) => theme.fontFamily.primary};
    background-color: ${({ theme }) => theme.colors.white};
    overflow-x: hidden;

    &[class^="scroll-lock"] {
      overflow: hidden;
    }
  }

  ol, ul {
	  list-style: none;
	}

  a {
    color: inherit;
    text-decoration: none;
  }

  button, input[type="submit"], input[type="reset"] {
    font-family: inherit;
    font-size: inherit;
    background: none;
  }

  ::-webkit-scrollbar-track {
    border-radius: ${({ theme }) => theme.radius.xs};
    background-color: ${({ theme }) => theme.colors.transparent};
    overflow-x: auto;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: ${({ theme }) => theme.colors.transparent};
    overflow-x: auto;

    &:hover {
      width: 12px;
      height: 12px;
    }
  }

  ::-webkit-scrollbar-thumb {
    border-radius:${({ theme }) => theme.radius.sm};
    background-color: ${({ theme }) => theme.colors.primary.variant7};
    overflow-x: auto;
  }

  /* Allow clicking on elements on touch devices during the onboarding tour */
  @media (hover: none) {
    .react-joyride__overlay,
    .react-joyride__spotlight {
      pointer-events: none !important;
    }
  }


`;

export default GlobalStyle;
